import React from 'react';
import { StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonList,
  SkeletonListItem,
} from '@/components/common/skeleton';

export const ResidentListSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <SkeletonList count={8} gap={8}>
      <SkeletonListItem
        avatar
        avatarSize={40}
        lines={2}
        lineWidths={[160, 100]}
      />
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 12,
  },
});
